package banner

import editor.structure.Structure
import editor.structure.center
import editor.structure.instantiate
import ext.plus
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json
import org.w3c.dom.url.URLSearchParams
import rendering.RendererManager
import rendering.SceneManager
import three.js.Group
import util.DebugManager

// todo some kind of "table" plane to
//  make the structure stand on something
// todo "reset pan" button (top right?)
/**
 * ## Banner Animation
 *
 * Structures move from one side of the screen to the other.
 */
object BannerManager {
    private const val OFFSET = 300
    private const val BUFFER = 5
    private var x = 0.0
    private val maxX get() = structures.size * OFFSET

    /**
     * The group of THREE objects that are currently in the viewer.
     */
    private val objects = Group().apply {

    }

    /**
     * The group of THREE objects that are directly added to the scene.
     */
    private val group = Group().apply {
        add(objects)
    }

    private var structures: List<Structure> = emptyList()

    /**
     * Called once at the beginning to initialize the banner.
     *
     * - add the html
     * - add the group which contains the structure
     * - add mousedown/-up listeners for switching between states
     */
    suspend fun init() {
        val params = URLSearchParams(document.location!!.search)
        val bannerId = params.get("id") ?: "start40"
        val bannerData = window.fetch("/banners/$bannerId.timberix.json").await().text().await()
        structures = Json.decodeFromString<List<String>>(bannerData).map {
            val structureData = window.fetch("/structures/$it.timberix.json").await().text().await()
            Json.decodeFromString<Structure>(structureData)
        }
        (structures.takeLast(BUFFER).reversed() + structures + structures.take(BUFFER)).forEachIndexed { index, structure ->
            val structureGroup = Group().add(*structure.instantiate().map {
                it.clone(recursive = true).apply {
                    position.sub(structure.center)
                }
            }.toTypedArray())
            structureGroup.position.x = (index - BUFFER) * OFFSET.toDouble()
            group.add(structureGroup)
        }
        SceneManager.scene.add(group)
    }

    /**
     * Called every frame to update the banner.
     */
    fun render(dt: Double) {
        DebugManager.debug("Structure size: ${structures.size}")
        DebugManager.debug("Group children: ${group.children.size}")
        DebugManager.debug("X: $x")
        DebugManager.debug("Max X: $maxX")
        x -= dt * 0.07
        x %= maxX
        group.position.x = x
        group.children.forEach {
            // rotate
            it.rotation.y += dt * 0.0005
        }

        DebugManager.render()
        RendererManager.render()
    }
}